<div class="form-group row mb-0">
  <label class="col-sm-12 col-form-label label-admin noselect pe-0">{{title}}</label>
</div>

<app-admin-divider [dividerKind]="dividerKind"></app-admin-divider>
